export default __webpack_public_path__ + "ff3c9928db73ff019b9720c6fde39b13.png";